/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';
import {QuestionnaireModel} from "../../models/questionnaire-model";

export interface AccountQuestionnairesGetParams {
    accountGuid: string;
    includeArchived?: boolean;
}

export function accountQuestionnairesGet(http: HttpClient, rootUrl: string, params: AccountQuestionnairesGetParams, headers: HttpHeaders, context?: HttpContext): Observable<StrictHttpResponse<QuestionnaireModel[]>> {
    const rb = new RequestBuilder(rootUrl, accountQuestionnairesGet.PATH, 'get');

    for (let headerKey of headers.keys()) {
        rb.header(headerKey, headers.get(headerKey));
    }

    if (params.accountGuid) {
        rb.path('accountGuid', params.accountGuid, { 'style': 'simple' });
    }
    if (params.includeArchived !== undefined) {
        rb.query('includeArchived', params.includeArchived);
    }

    return http.request(
        rb.build({ responseType: 'json', accept: '*/*', context })
    ).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<QuestionnaireModel[]>;
        })
    );
}

accountQuestionnairesGet.PATH = '/api/v1/accounts/{accountGuid}/questionnaires';
